import { render, staticRenderFns } from "./GenericGridCard.vue?vue&type=template&id=4b903760&scoped=true&"
import script from "./GenericGridCard.vue?vue&type=script&lang=ts&"
export * from "./GenericGridCard.vue?vue&type=script&lang=ts&"
import style0 from "./GenericGridCard.vue?vue&type=style&index=0&id=4b903760&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b903760",
  null
  
)

export default component.exports